import { useState, useCallback, useLayoutEffect } from 'react';
import ResizeObserver from '@juggle/resize-observer';

const getSize = el => {
  if (!el) {
    return {
      width: 0,
      height: 0
    };
  }

  return {
    width: el.offsetWidth,
    height: el.offsetHeight
  };
};

const useComponentSize = ref => {
  const [componentSize, setComponentSize] = useState(
    getSize(ref ? ref.current : {})
  );

  const handleResize = useCallback(() => {
    if (ref.current) {
      setComponentSize(getSize(ref.current));
    }
  }, [ref, setComponentSize]);

  useLayoutEffect(() => {
    if (!ref.current) {
      return;
    }

    handleResize();

    if (typeof ResizeObserver === 'function') {
      let resizeObserver = new ResizeObserver(() => {
        handleResize();
      });
      resizeObserver.observe(ref.current);

      return () => {
        // eslint-disable-next-line react-hooks/exhaustive-deps
        resizeObserver.disconnect(ref.current);
        resizeObserver = null;
      };
    } else {
      window.addEventListener('resize', handleResize);

      return () => {
        window.removeEventListener('resize', handleResize);
      };
    }
  }, [handleResize, ref]);

  return componentSize;
};

export default useComponentSize;
